<template>
  <div class="test-card">
    <div class="test-title">
      <span
        v-if="
          !(
            (testInfo.status == 5 || testInfo.status == 4) &&
            testInfo.show_answer_rule == 2
          )
        "
        class="icon-status"
        :class="`status-${testInfo.status}`"
      >
        {{ testInfo.statusText }}
      </span>
      <span class="title" :title="testInfo.test_title">
        {{ testInfo.test_title }}
      </span>
    </div>
    <div class="test-card-info">
      <div class="item" v-for="item in testInfo.testInfo" :key="item.id">
        <label class="label">{{ item.label }}：</label>
        <span class="value">{{ item.value }}{{ item.unit }}</span>
      </div>
    </div>
    <div
      class="test-card-info"
      style="margin-top: 8px"
      v-if="testInfo.test_status != 0 && testInfo.test_status != -1"
    >
      <div class="item" v-for="item in testInfo.packageInfo" :key="item.id">
        <label class="label">{{ item.label }}：</label>
        <span class="value">{{ item.value }}</span>
      </div>
    </div>
    <div class="test-card-info" style="margin-top: 8px">
      <div class="item">
        <label class="label">考试时间：</label>
        <span class="value" v-if="testInfo.start_time != '--'">
          {{ testInfo.start_time }} ~ {{ testInfo.end_time }}
        </span>
        <span class="value" v-else>永久</span>
      </div>
    </div>
    <div
      v-if="testInfo.courseList && testInfo.courseList.length"
      class="from-course"
    >
      来自课程
      <span class="course-name" @click="seeCourse">
        《{{ testInfo.courseList[0] }}》
      </span>
    </div>
    <!--    过期 并且没有参加过考试-->
    <template v-if="!(testInfo.has_expired == 1 && !testInfo.has_tested_num)">
      <div class="test-button">
        <div class="default" @click="seeDetail" v-if="canDetail()">
          查看详情
        </div>
        <div class="primary-button" @click="inToTest" v-if="canTest()">
          {{ testInfo.test_status == 0 ? "继续考试" : "参加考试" }}
        </div>
      </div>
      <div
        class="test-grade"
        v-if="
          (testInfo.test_status == 1 || testInfo.test_status == 3) &&
          testInfo.show_answer_rule == 1
        "
      >
        <div style="text-align: center">{{ testInfo.get_score }}</div>
        <img src="../../../images/member/Vector@2x.png" />
      </div>
    </template>
    <TestConditionModal
      :showModal.sync="showModal"
      :testCondition="testCondition"
    />
    <TestCheckModal ref="checkModal" />
  </div>
</template>

<script>
import TestConditionModal from "./TestConditionModal";
import TestCheckModal from "./TestCheckModal";

export default {
  name: "TestCard",
  components: {
    TestConditionModal,
    TestCheckModal,
  },
  props: {
    testInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      remindType: {},
      courseList: [],
      testCondition: {},
      showModal: false,
      showOverModal: false,
    };
  },
  methods: {
    async inToTest() {
      //先校验是否达到考试条件，如果没有
      await this.$refs.checkModal.init(this.testInfo.id);
      //继续考试，不需要进去试卷介绍页
      if (this.testInfo.test_status == 0) {
        this.$router.push({
          name: "TestDo",
          query: {
            id: this.testInfo.report_id,
            package_id: this.testInfo.id,
          },
        });
        return;
      }
      //否则去考试
      this.$router.push({
        name: "TestDetail",
        query: { id: this.testInfo.id },
      });
    },
    seeDetail() {
      this.$router.push({
        name: "TestReport",
        params: {
          id: this.testInfo.current_report_id,
        },
      });
      //进入试卷详情页
    },
    async getCourseList() {
      const res = await this.$http.get("/api/app/test/testCondition", {
        id: this.testInfo.id,
      });
      this.testCondition = {
        name: res[0].test_title,
        courseList: res || [],
        join_type: res[0].join_type,
      };
    },
    //查看课程列表modal
    async seeCourse() {
      await this.getCourseList();
      this.showModal = true;
    },
    //判断是否可以参加考试  未提交，待考试，已批阅，已提交（不需要人工批阅）并且考试次数没有用完，并且未过期，都可以参加考试
    canTest() {
      if (
        this.testInfo.test_status != 2 &&
        (this.testInfo.times == 0 ||
          this.testInfo.has_tested_num < this.testInfo.times) &&
        this.testInfo.has_expired == 0
      ) {
        return true;
      }
      return false;
    },
    //是否可以查看详情  已经作答过
    canDetail() {
      if (this.testInfo.has_tested_num >= 1) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.test-card {
  position: relative;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  padding: 22px 24px 20px 20px;
  .test-title {
    .icon-status {
      display: inline-block;
      width: 60px;
      height: 26px;
      opacity: 1;
      text-align: center;
      line-height: 26px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      border-radius: 3px;
      margin-right: 12px;
      vertical-align: middle;
    }
    .status-1 {
      background: rgba(253, 90, 39, 0.1);
      color: #fd5a27;
    }
    .status-2 {
      background: rgba(255, 36, 36, 0.1);
      color: #ff2424;
    }
    .status-3 {
      background: rgba(255, 200, 36, 0.2);
      color: #f28300;
    }
    .status-4 {
      background: rgba(29, 204, 102, 0.1);
      color: #1dcc66;
    }
    .status-5 {
      background: rgba(255, 36, 36, 0.1);
      color: #ff2424;
    }
    .status-6 {
      background: #eaeaea;
      color: #666666;
    }
    .title {
      display: inline-block;
      height: 22px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      vertical-align: middle;
      max-width: 500px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .test-card-info {
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    display: flex;
    margin-top: 16px;
    .item {
      padding-right: 12px;
      margin-right: 12px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 18px;
        background: #bfbfbf;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &:last-child::after {
        display: none;
      }
    }
  }
  .from-course {
    margin-top: 16px;
    height: 22px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    line-height: 22px;
    .course-name {
      display: inline-block;
      color: $primary-color;
      margin-left: 8px;
      cursor: pointer;
    }
    .course-name:hover {
      color: $primary-color-hover;
    }
  }
  .test-button {
    position: absolute;
    top: 20px;
    right: 24px;
    display: flex;
    .default {
      width: 104px;
      height: 38px;
      opacity: 1;
      border: 1px solid #cccccc;
      border-radius: 32px;

      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: center;
      color: #666;
      line-height: 38px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .primary-button {
      margin-left: 12px;
      width: 104px;
      height: 38px;
      background: $primary-color;
      border-radius: 32px;

      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      text-align: center;
      color: #fff;
      line-height: 38px;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
  .test-grade {
    position: absolute;
    top: 77px;
    right: 29px;

    font-size: 28px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #ff2424;
    line-height: 30px;
    img {
      //display: inline-block;
      width: 38px;
      height: 15px;
      position: relative;
      top: -7px;
    }
  }
}
</style>
